import { NODE_CLOSE, NODE_EXPAND, NODE_TOGGLE } from './treeviewActions';

export const initialState = {
  expandedNodes: [],
};

const treeviewReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case NODE_EXPAND: {
      return {
        ...state,
        expandedNodes: state.expandedNodes.includes(action.nodeId)
          ? state.expandedNodes
          : [...state.expandedNodes, action.nodeId],
      };
    }
    case NODE_CLOSE: {
      return {
        ...state,
        expandedNodes: state.expandedNodes.includes(action.nodeId)
          ? state.expandedNodes.filter(nodeId => action.nodeId !== nodeId)
          : state.expandedNodes,
      };
    }
    case NODE_TOGGLE: {
      return {
        ...state,
        expandedNodes: state.expandedNodes.includes(action.nodeId)
          ? state.expandedNodes.filter(nodeId => action.nodeId !== nodeId)
          : [...state.expandedNodes, action.nodeId],
      };
    }

    default:
      return state;
  }
};

export default treeviewReducer;
